"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArrayBuffer = void 0;
const isArrayBuffer = (variable) => {
    return variable instanceof ArrayBuffer;
};
exports.isArrayBuffer = isArrayBuffer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXMtYXJyYXlidWZmZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvdXRpbC9sb2Rhc2gtZnVuY3Rpb25zL2lzLWFycmF5YnVmZmVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFPLE1BQU0sYUFBYSxHQUFHLENBQUMsUUFBYSxFQUEyQixFQUFFO0lBQ3BFLE9BQU8sUUFBUSxZQUFZLFdBQVcsQ0FBQztBQUMzQyxDQUFDLENBQUM7QUFGVyxRQUFBLGFBQWEsaUJBRXhCIn0=